import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CouponService {

  baseUrl = environment.baseUrl;

  coupon_form = new FormGroup({
    id: new FormControl(null),
    coupon_code: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    discount_type: new FormControl('', [Validators.required]),
    discount_value: new FormControl('', [Validators.required, Validators.min(1)]),
    minimum_order_value: new FormControl('', [Validators.required, Validators.min(0)]),
    maximum_discount: new FormControl('', [Validators.required, Validators.min(0)]),
    start_date: new FormControl('', [Validators.required]),
    end_date: new FormControl('', [Validators.required]),
    usage_limit: new FormControl('', [Validators.required, Validators.min(1)]),
  });

  constructor(private http: HttpClient,
    private loading: LoadingService,
    private datePipe: DatePipe,
  ) { }

  // get_active_coupon() {
  //   return this.http.get(this.baseUrl + '/coupons');
  // }

  get_all_coupons() {
    return this.http.get(this.baseUrl + '/get_all_coupons');
  }

  populateForm(rowData: any) {
    this.coupon_form.setValue(_.omit(rowData, 'company_id', 'created_at',
      'deleted_at', 'updated_at', 'is_active', 'user_id', 'used_count'));
  }

  insert_coupon(formData: any) 
  {
    return this.http.post(this.baseUrl + '/create_coupon',{
      coupon_code: formData.coupon_code,
      description : formData.description,  
      discount_type : formData.discount_type,
      discount_value : formData.discount_value, 
      minimum_order_value : formData.minimum_order_value,
      maximum_discount : formData.maximum_discount,
      start_date : formData.start_date,
      end_date : formData.end_date,
      usage_limit : formData.usage_limit,
    });
  }
  
  //this.datePipe.transform(formData.start_date, 'yyyy-MM-dd'))
   
  

  update_coupon(formData: any) 
  {
    //console.log(formData);
    return this.http.post(this.baseUrl + '/update_coupon/' + formData.id, {
    id : formData.id,
    coupon_code : formData.coupon_code,
    description : formData.description,
    discount_type : formData.discount_type,
    discount_value : formData.discount_value,
    minimum_order_value: formData.minimum_order_value,
    maximum_discount: formData.maximum_discount,
    start_date: formData.start_date,
    end_date: formData.end_date,
    usage_limit: formData.usage_limit,
    });
  }

  update_coupon_status(couponId, status) {
    return this.http.get(this.baseUrl + '/update_coupon_status/' + couponId + '/' + status);
  }

  delete_coupon(id: any) {
    return this.http.get(this.baseUrl + '/delete_coupon/' + id);
  }


}
